<div class="container">
  <!-- Stats Section -->
  <div class="header-section">
    <div class="stats-container">
      <div class="stat-card">
        <h5>Éléments</h5>
        <div class="stat-value">{{ initialTotalItems }}</div>
      </div>
      <div class="stat-card">
        <h5>Montant Impayé</h5>
        <div class="stat-value">{{ paymentDetails.unpaid | number:'1.2-2' }} MAD</div>
      </div>
      <div class="stat-card">
        <h5>Montant Payé</h5>
        <div class="stat-value">{{ paymentDetails.paid | number:'1.2-2' }} MAD</div>
      </div>
    </div>

    <!-- Actions and Filters -->
    <div class="actions-container">
      <button class="btn-pay" (click)="paySelectedItems()">
        <i class="bx bx-credit-card"></i>
        Effectuer le Paiement
      </button>

      <div class="search-filters">
        <input 
          (input)="onInputChange($event)" 
          type="search" 
          class="form-control" 
          placeholder="Rechercher...">

        <input 
          (change)="onDateChange($event)" 
          type="date" 
          class="form-control">

        <select 
          (change)="onStatusChange($event)" 
          class="form-control">
          <option selected value="">Statut</option>
          <option value="true">Payé</option>
          <option value="false">Impayé</option>
        </select>

        <div class="dropdown">
          <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenu4" data-bs-toggle="dropdown" aria-expanded="false">
            Actions
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenu4">
            <li><a class="dropdown-item" (click)="navigateTo('addOrder')">Créer une Facture</a></li>
            <li><a class="dropdown-item" (click)="navigateTo('addCashLoan')">Ajouter un Prêt</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="spinner-container">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Chargement...</span>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && pagedList.length === 0" class="empty-state">
    <div class="empty-state-content">
      <div class="empty-state-icon">
        <i class='bx bx-file'></i>
      </div>
      <h3 class="empty-state-title">Aucune commande n'est trouvée</h3>
      <p class="empty-state-description">
        Il n'y a aucune commande correspondant à vos critères. Vous pouvez soit modifier vos filtres, soit créer une nouvelle commande.
      </p>
      <div class="empty-state-actions">
        <button class="btn btn-outline-secondary me-2" (click)="resetAndFetch()">
          <i class='bx bx-reset'></i>
          Réinitialiser les filtres
        </button>
        <button class="btn btn-primary gradient-primary" (click)="navigateTo('addOrder')">
          <i class='bx bx-plus'></i>
          Nouvelle commande
        </button>
      </div>
    </div>
  </div>

  <!-- Content when items exist -->
  <div *ngIf="!isLoading && pagedList.length > 0">
    <!-- Desktop Table View -->
    <div class="table-container">
      <table class="project-list-table">
        <thead>
          <tr>
            <th>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [checked]="allSelected" (change)="toggleSelectAll($event)" />
              </div>
            </th>
            <th>Type</th>
            <th>État</th>
            <th>Montant</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of pagedList">
            <td>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" [(ngModel)]="item.selected" (change)="checkIfAllSelected()" />
              </div>
            </td>
            <td>
              <span *ngIf="item.type === 'order'" style="cursor: pointer;" (click)="goToOrderDetails(item.id)">Facture</span>
              <span *ngIf="item.type !== 'order'">Prêt</span>
            </td>
            <td>
              <span class="badge" [matTooltip]="getAdvanceTooltip(item)"
                [ngClass]="{'badge-soft-success': isOrderLoanPaid(item), 'badge-soft-danger': !isOrderLoanPaid(item)}">
                {{ isOrderLoanPaid(item) ? 'Payé' : 'Impayé' }}
              </span>
            </td>
            <td>
              <span [matTooltip]="getTooltip(item)">{{ item.total || item.amount }} MAD</span>
            </td>
            <td>{{ item.orderDate || item.loanDate | date: 'dd MMMM yyyy' : '' : 'fr' }}</td>
            <td>
              <button class="action-btn edit" (click)="navigateToEdit(item)" matTooltip="Modifier">
                <i class="bx bx-pencil"></i>
              </button>
              <button class="action-btn delete" matTooltip="Supprimer">
                <i class="bx bx-trash-alt"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile Card View -->
    <div class="mobile-cards">
      <div class="mobile-card" *ngFor="let item of pagedList">
        <div class="mobile-card-header">
          <div class="form-check">
            <input type="checkbox" class="form-check-input" [(ngModel)]="item.selected" (change)="checkIfAllSelected()" />
          </div>
          <span class="badge" [matTooltip]="getAdvanceTooltip(item)"
            [ngClass]="{'badge-soft-success': isOrderLoanPaid(item), 'badge-soft-danger': !isOrderLoanPaid(item)}">
            {{ isOrderLoanPaid(item) ? 'Payé' : 'Impayé' }}
          </span>
        </div>
        <div class="mobile-card-body">
          <div class="mobile-card-item">
            <span class="mobile-card-label">Type</span>
            <span class="mobile-card-value" [class.clickable]="item.type === 'order'" (click)="item.type === 'order' && goToOrderDetails(item.id)">
              {{ item.type === 'order' ? 'Facture' : 'Prêt' }}
            </span>
          </div>
          <div class="mobile-card-item">
            <span class="mobile-card-label">Montant</span>
            <span class="mobile-card-value" [matTooltip]="getTooltip(item)">{{ item.total || item.amount }} MAD</span>
          </div>
          <div class="mobile-card-item">
            <span class="mobile-card-label">Date</span>
            <span class="mobile-card-value">{{ item.orderDate || item.loanDate | date: 'dd MMM yyyy' : '' : 'fr' }}</span>
          </div>
          <div class="mobile-card-actions">
            <button class="btn btn-sm btn-outline-primary" (click)="navigateToEdit(item)">
              <i class="bx bx-pencil"></i> Modifier
            </button>
            <button class="btn btn-sm btn-outline-danger ms-2">
              <i class="bx bx-trash-alt"></i> Supprimer
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <app-paginator
      [totalItems]="totalItems"
      [itemsPerPage]="itemsPerPage"
      [currentPage]="currentPage"
      [pages]="pages"
      [pagedItemsSize]="pagedList.length"
      (pageChange)="onPageChange($event)">
    </app-paginator>
  </div>
</div>
